// src/locales/en/dashboard.js
export const dashboard = {
    welcomeBack: "Welcome back, {{name}}! 👋",
    businessOverview: "Here's what's happening with your business today.",
    totalOrders: "Total Orders",
    products: "Products",
    revenue: "Revenue",
    customers: "Customers",
    salesUp: "Sales up 12% this week",
    recentActivity: "Recent Activity",
    quickActions: "Quick Actions",
    accountInfo: "Account Information",
    businessName: "Business Name",
    yourRole: "Your Role",
    memberSince: "Member Since",
    permissions: "Permissions",
    permissionsCount: "{{count}} permissions assigned",
    fromLastMonth: "from last month",
    orderList: "Order List",
    productList: "Product List",
    newBatch: "New Packing Batch",
    dispatchOrders: "Dispatch Orders",
    orderList: "Order List",
    
    // Key Metrics
    keyMetrics: "Key Metrics",
    todaysSales: "Today's Sales",
    thisWeek: "This Week",
    thisMonth: "This Month",
    avgOrderValue: "Average Order Value",
    orders: "Orders",
    vsLastWeek: "vs last week",
    vsLastMonth: "vs last month",
    vsYesterday: "vs yesterday",
    todayVsYesterday: "Today vs yesterday",
    vsLastWeekSameDays: "vs last week to date",
    vsLastMonthSameDays: "vs last month to date",
    weekToDateVsLastWeek: "This week vs last week to date",
    weekToDateVsFullLastWeek: "This week vs full last week",
    monthToDateVsLastMonth: "This month vs last month to date",
    monthToDateVsFullLastMonth: "This month vs full last month",
    salesValue: "Sales value",
    
    // Order Status Distribution
    ordersByStatus: "Orders by Status",
    statusDistribution: "Status Distribution",
    totalOrderValue: "Total Order Value",
    orderCount: "Order Count",
    orderValue: "Order Value",
    barChart: "Bar Chart",
    
    // Sales Trend
    salesTrend: "Sales Trend",
    salesValue: "Sales Value",
    orderQuantity: "Order Quantity",
    last7Days: "Last 7 Days",
    last14Days: "Last 14 Days",
    last30Days: "Last 30 Days",
    
    // Top Products
    topProducts: "Top Selling Products",
    product: "Product",
    quantitySold: "Quantity Sold",
    revenueGenerated: "Revenue",
    
    // Filters
    allShops: "All Shops",
    selectShop: "Select Shop",
    dateRange: "Date Range",
    today: "Today",
    yesterday: "Yesterday",
    thisWeekLabel: "This Week",
    lastWeek: "Last Week",
    thisMonthLabel: "This Month",
    lastMonth: "Last Month",
    customRange: "Custom Range",
    applyFilters: "Apply Filters",
    
    // Loading & Errors
    loading: "Loading...",
    loadingData: "Loading dashboard data...",
    errorLoading: "Error loading data",
    noData: "No data available",
    tryAgain: "Try Again",
    
    // Empty States
    noOrdersFound: "No orders found",
    noProductsFound: "No products found",
    noDataForPeriod: "No data available for the selected period",
    
    // Work Queue
    workQueue: "Work Queue",
    assigned: "Assigned",
    allOrders: "All Orders",
    viewAll: "View All",
    noOrdersInQueue: "No orders in queue",
    myWorkQueue: "My Work Queue",
    
    // Inventory Alerts
    inventoryAlerts: "Inventory Alerts",
    allWarehouses: "All Warehouses",
    threshold: "Threshold",
    lowStockItems: "Low Stock Items",
    outOfStockItems: "Out of Stock Items",
    lowStock: "Low Stock",
    outOfStock: "Out of Stock",
    noInventoryAlerts: "All inventory levels are healthy",
    
    // Packing Activity
    packingActivity: "Packing Activity",
    todayBatches: "Today's Batches",
    readyToPack: "Ready to Pack",
    inPacking: "In Packing",
    dispatchedToday: "Dispatched Today",
    courierBreakdown: "Courier Breakdown",
    
    // Courier Returns
    courierReturns: "Courier Returns",
    returns: "Returns",
    noReturns: "No returns for this period",
}